import React from "react";

const TONE = { pagata: "bg-emerald-100 text-emerald-800", scaduta: "bg-red-100 text-red-700", in_scadenza: "bg-amber-100 text-amber-800", da_pagare: "bg-stone-100 text-stone-600" };
const LABEL = { pagata: "Pagata", scaduta: "Scaduta", in_scadenza: "In scadenza", da_pagare: "Da pagare" };
export const eur = (v) => `€ ${(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const itDate = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00`).toLocaleDateString("it-IT") : "—");

export function InstStatus({ s, testId }) {
  return <span className={`text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${TONE[s]}`} data-testid={testId}>{LABEL[s]}</span>;
}

export function PlanSummary({ plan }) {
  const pct = plan.total ? Math.min(100, Math.round((plan.paid / plan.total) * 100)) : 0;
  return (
    <div className="space-y-2" data-testid="plan-summary">
      <div className="grid grid-cols-3 gap-3 text-sm">
        <div><div className="text-[11px] uppercase tracking-widest text-stone-500">Totale</div><div className="text-lg font-semibold" data-testid="plan-total">{eur(plan.total)}</div></div>
        <div><div className="text-[11px] uppercase tracking-widest text-stone-500">Pagato</div><div className="text-lg font-semibold text-emerald-700" data-testid="plan-paid">{eur(plan.paid)}</div></div>
        <div><div className="text-[11px] uppercase tracking-widest text-stone-500">Residuo</div><div className={`text-lg font-semibold ${plan.overdue_count ? "text-red-700" : ""}`} data-testid="plan-residual">{eur(plan.residual)}</div></div>
      </div>
      <div className="h-2 rounded-full bg-stone-100 overflow-hidden"><div className="h-full bg-emerald-600" style={{ width: `${pct}%` }}/></div>
      <div className="text-xs text-stone-500">{plan.plan_label} · anno {plan.academic_year || "—"}{plan.overdue_count ? <span className="text-red-700"> · {plan.overdue_count} rat{plan.overdue_count === 1 ? "a" : "e"} scadut{plan.overdue_count === 1 ? "a" : "e"} ({eur(plan.overdue_amount)})</span> : null}</div>
    </div>
  );
}
